import React, {useState, useEffect, useRef} from "react";
import logo from "../assets/images/logo.svg";
import mazar2 from "../assets/images/mazar2.jpg";
import candle from "../assets/images/candle.jpg";
import Footer from "./Footer";
import TopNav from "./TopNav";
import sia, {IMG_DIR} from "../services/Api";
import LoaderView from "../tools/LoaderView";
import {Button} from "@material-ui/core";
import {notifyError, notifyErrorMessage, notifySuccessfulMessage} from "../App";
import headerBanner from '../assets/images/header-poster1.jpg'
import 'react-toastify/dist/ReactToastify.css';
import {ToastContainer, toast, Slide} from 'react-toastify'
import CustomDatePicker from "./modals/CustomDatePicker";

const MotevafaEdit = (props) => {
    const url = window.location.pathname;

    const dead_id = url.substr(15, 24);

    const [dead, setDead] = useState([]);
    const [data, setData] = useState([]);
    const [isLoading, setLoading] = useState(false)
    const [prays, setPrays] = useState([]);

    const [irStates, setIrStates] = useState([]);
    const [irCities, setIrCities] = useState([]);

    const [prayArray, updateprayArray] = useState([]);

    const [faceFile, setFaceFile] = useState(null)
    const [headerFile, setHeaderFile] = useState(null)
    const [tombFile, setTombFile] = useState(null)
    const [facePreview, setFacePreview] = useState(null)
    const [headerPreview, setHeaderPreview] = useState(null)
    const [tombPreview, setFaceTombPreview] = useState(null)

    const [isLoadingCities, setLoadingCities] = useState(true);

    const [isShowingDatePicker1, setIsShowingDatePicker1] = useState(false)
    const [isShowingDatePicker2, setIsShowingDatePicker2] = useState(false)
    const [birthDate, setBirthDate] = useState('');
    const [deadDate, setDeadDate] = useState('');

    const selectedStateIndex = useRef()
    const selectedCityIndex = useRef()

    useEffect(() => {
        getStates()
        getDead()
        getPrays()
        console.log(prays, data)
    }, []);

    const getPrays = async () => {
        setLoading(true)
        await sia
            .getDataFromServer("/pray")
            .then((res) => {
                setPrays(res.data);
            })
            .catch((err) => {
            });
        setLoading(false)
    }

    const soundHandle = (e) => {
        e.persist();
        updateprayArray((arr) => [...arr, e.target.value]);
    };

    const getStates = async () => {
        setLoading(true)
        await sia
            .getDataFromServer("/state")
            .then((res) => {
                setIrStates(res.data);
            })
            .catch((err) => {
            });

        setLoading(false)
    }

    const getDead = async () => {
        setLoading(true)
        await sia
            .getDataFromServer("/dead/" + dead_id)
            .then((res) => {
                setDead(res.data);
                setData(res.data)
                setDeadDate(res.data.deathDate)
                setBirthDate(res.data.birthday)
            })
            .catch((err) => {
            });

        setLoading(false)
    }

    const getCities = async () => {
        setIrCities([])
        setLoadingCities(true)
        await sia
            .getDataFromServer("city?state_id=" + irStates[selectedStateIndex.current].id)
            .then((res) => {
                setIrCities(res.data);
            })
            .catch((err) => {
            });
        setLoadingCities(false)
    }

    const handleMotevafaEdit = async (e) => {
        e.preventDefault()
        if ((e.target.elements.name.value == '') || (e.target.elements.matnTasliat.value == '') || (e.target.elements.gender.value == '') || (e.target.elements.birthday.value == '') || (e.target.elements.deathDate.value == '') || (e.target.elements.disc.value == '') || (e.target.elements.address.value == '')) {
            notifyErrorMessage('لطفا تمامی بخش ها را پر کنید')
        } else {
            console.log("name", (e.target.elements.name.value == ''))
            console.log("matnTasliat", (e.target.elements.matnTasliat.value == ''))
            console.log("gender", (e.target.elements.gender.value == ''))
            console.log("birthday", (e.target.elements.birthday.value == ''))
            console.log("deathDate", (e.target.elements.deathDate.value == ''))
            console.log("disc", (e.target.elements.disc.value == ''))
            console.log("address", (e.target.elements.address.value == ''))
            setLoading(true)
            const data = new FormData();
            data.append("id", dead._id);
            data.append("name", e.target.elements.name.value);
            data.append("matnTasliat", e.target.elements.matnTasliat.value);
            data.append("gender", e.target.elements.gender.value);
            data.append("birthday", e.target.elements.birthday.value);
            data.append("deathDate", e.target.elements.deathDate.value);
            data.append("disc", e.target.elements.disc.value);
            data.append("address", e.target.elements.address.value);
            // data.append("pictureAddress",e.target.elements.pictureAddress.value);
            if (headerFile) data.append("pictureHeader", headerFile)
            if (tombFile) data.append("pictureAddress", tombFile)
            if (faceFile) data.append("picture", faceFile);
            data.append("city_id", e.target.elements.city_id.value)
            // data.append("enterSound_id",e.target.elements.enterSound_id.value)

            prayArray.forEach((item) => {
                data.append("prays_id[]", item);
            })

            //TODO delete this:
            data.append("confirm", "1")
            // console.log(JSON.stringify(prayArray));
            // const token = localStorage.getItem("token");
            await sia
                .PostDataToServer("/dead", data)
                .then((res) => {
                    if (res.status == 200) {
                        setFacePreview(null)
                        notifySuccessfulMessage('با موفقیت ثبت شد')
                        // window.location = './d-list?mine=true'
                    }
                    // console.log(res);
                    // props.history.push("/profile");
                })
                .catch((err) => {
                    // console.log(err)
                    notifyError()
                });
            setLoading(false)
        }
    }

    const addFileFromFilePicker = (e) => {
        const files = e.target.files || e.dataTransfer.files;
        if (files && files.length > 0) {
            if (files[0].size > 820000) {
                notifyErrorMessage("حجم عکس باید کمتر از 800 کیلوبایت باشد")
            } else {
                setFacePreview(URL.createObjectURL(files[0]));
                setFaceFile(files[0])
            }
        }

    }

    const addTombFileFromFilePicker = (e) => {
        const files = e.target.files || e.dataTransfer.files;
        if (files && files.length > 0) {
            if (files[0].size > 820000) {
                notifyErrorMessage("حجم عکس باید کمتر از 800 کیلوبایت باشد")
            } else {
                setFaceTombPreview(URL.createObjectURL(files[0]));
                setTombFile(files[0])
            }
        }
    }

    const addHeaderFileFromFilePicker = (e) => {
        const files = e.target.files || e.dataTransfer.files;
        if (files && files.length > 0) {
            if (files[0].size > 820000) {
                notifyErrorMessage("حجم عکس باید کمتر از 800 کیلوبایت باشد")
            } else {
                setHeaderPreview(URL.createObjectURL(files[0]));
                setHeaderFile(files[0])
            }
        }
    }

    const readUrl = (file) => {
        if (file) {
            var reader = new FileReader();

            reader.onload = (e) => {
                setFaceFile(file);
            };
            reader.readAsDataURL(file);
        }
    };
    return (
        <>
            <ToastContainer rtl closeOnClick pauseOnHover position="top-center" transition={Slide}/>
            {isShowingDatePicker1 && <CustomDatePicker isOpen={isShowingDatePicker1} onChange={(d) => {
                setBirthDate(d)
                setIsShowingDatePicker1(false)
            }} onClose={() => setIsShowingDatePicker1(false)}/>}

            {isShowingDatePicker2 && <CustomDatePicker isOpen={isShowingDatePicker2} onChange={(d) => {
                setDeadDate(d)
                setIsShowingDatePicker2(false)
            }} onClose={() => setIsShowingDatePicker2(false)}/>}

            <header>
                <div class="pagewrapper" id="header-big">
                    <div class="container">
                        <TopNav/>
                    </div>
                    <div class="header-poster poster1" style={{
                        objectFit: 'cover',
                        backgroundImage: !headerPreview ? `url(${IMG_DIR + dead.pictureHeader})` : `url(${headerPreview})`
                    }}>
                        <div class="container">
                            <div class="upload-box box-sizing radius10">
                                <div class="upload-btn box-sizing radius10 clickable"
                                     onClick={() => document.getElementById('image1').click()}>

                                    <svg width="55" height="55" fill="#fff" viewBox="0 0 53.18 54.738">
                                        <defs>
                                            <style
                                                dangerouslySetInnerHTML={{
                                                    __html: ".cls-1{fill:#fff}",
                                                }}
                                            />
                                        </defs>
                                        <path id="Path_755"
                                              d="M44.87 0H8.309C3.727 0 0 4.127 0 9.2v32.2c0 5.073 3.727 9.2 8.309 9.2h28.356a2.312 2.312 0 0 0 0-4.6h-7.651l-4.776-6.86 15.135-21.317 10.189 12.469a1.943 1.943 0 0 0 2.287.6 2.308 2.308 0 0 0 1.33-2.146V9.2c0-5.073-3.727-9.2-8.309-9.2zm4.155 22.779L40.8 12.716a1.984 1.984 0 0 0-1.612-.756 2.021 2.021 0 0 0-1.561.877L21.621 35.38l-5.434-7.805a2.014 2.014 0 0 0-1.645-.9 2.014 2.014 0 0 0-1.645.9l-4.572 6.58a2.468 2.468 0 0 0 .38 3.225 1.947 1.947 0 0 0 2.914-.42l2.927-4.213L23.768 46H8.309a4.4 4.4 0 0 1-4.155-4.6V9.2a4.4 4.4 0 0 1 4.155-4.6H44.87a4.4 4.4 0 0 1 4.155 4.6zm0 0"
                                              class="cls-1"/>
                                        <path id="Path_756"
                                              d="M86.232 72C82.8 72 80 75.1 80 78.9s2.8 6.9 6.232 6.9 6.232-3.1 6.232-6.9-2.795-6.9-6.232-6.9zm0 9.2a2.312 2.312 0 1 1 2.077-2.3 2.2 2.2 0 0 1-2.077 2.3zm0 0"
                                              class="cls-1" transform="translate(-71.691 -63.72)"/>
                                        <path id="Path_757"
                                              d="M364.994 289.718l-.018-.021a4.833 4.833 0 0 0-7.347-.01l-4.011 4.38a2.477 2.477 0 0 0-.02 3.252 1.938 1.938 0 0 0 2.938.022l2.685-2.931v12.909a2.088 2.088 0 1 0 4.155 0V294.48l2.569 2.939a1.939 1.939 0 0 0 2.938.053 2.477 2.477 0 0 0 .047-3.252zm0 0"
                                              class="cls-1" transform="translate(-316.335 -254.881)"/>
                                    </svg>
                                    <p>فایل را اینجا رها کنید</p>
                                    <input type="file" style={{display: 'none'}} id="image1" name="image1"
                                           class="dropify" data-allowed-file-extensions="gif png jpg jpeg"
                                           data-max-file-size="1M"
                                           onChange={addHeaderFileFromFilePicker}/>
                                </div>
                                <div class="left-col box-sizing">
                                    ضمن عرض تسلیت و احترام به خانواده و بازماندگان تقاضا می گردد با توجه به شئونات
                                    اسلامی و با عنایت به رویت عمومی صفحه تصویری را انتخاب نمایید
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>
            <div className="clear"/>
            {isLoading ? <LoaderView/> : <form
                action
                id="motevafa-details-form"
                method="post"
                onSubmit={handleMotevafaEdit}
            >
                <div className="pagewrapper" id="motevafa-profile-image">
                    <div className="container box-sizing radius10">
                        <div className="col-right">
                            <h2 className="desc">تصویر متوفی (با رعایت شئونات اسلامی)</h2>
                            <div className="upload-box box-sizing radius10">
                                {/**/}
                                <img
                                    src={!facePreview ? IMG_DIR + dead.picture : facePreview}
                                    alt=""
                                    className="thumb cover radius10"
                                    width={225}
                                    height={241}
                                />
                                <div className="upload-btn box-sizing radius10">
                                    <Button fullWidth onClick={() => document.getElementById('imagePicker').click()}
                                            style={{height: 50}}>انتخاب تصویر</Button>
                                    <input
                                        id="imagePicker"
                                        type="file"
                                        onChange={addFileFromFilePicker}
                                        name="picture"
                                        style={{display: 'none'}}
                                        data-allowed-file-extensions="gif png jpg jpeg"
                                        data-max-file-size="1M"
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-left">
                            {/*<p className="desc">متن تسلیت شما و مندرجات داخل صفحه را در فضای زیر بنویسید</p>*/}
                            <textarea
                                name="matnTasliat"
                                value={dead.matnTasliat}
                                placeholder="متن تسلیت..."
                                className="input radius10 box-sizing"
                            />
                        </div>
                    </div>
                </div>
                <div className="pagewrapper" id="motevafa-mazar-image">
                    <div className="container box-sizing radius10">
                        <div className="col-right">
                            <div className="upload-box box-sizing radius10 clickable"
                                 onClick={() => document.getElementById('image3').click()}>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width={55}
                                    height={55}
                                    fill="#fff"
                                    viewBox="0 0 60.663 62.709"
                                >
                                    {" "}
                                    <defs>
                                        <style
                                            dangerouslySetInnerHTML={{__html: ".cls-1{fill:#fff}"}}
                                        />
                                    </defs>
                                    {" "}
                                    <g id="upload-file">
                                        {" "}
                                        <path
                                            id="Path_765"
                                            d="M52.73 19.1v14.329H8.9V19.1H.489v18.54A4.208 4.208 0 0 0 4.7 41.849h52.235a4.21 4.21 0 0 0 4.217-4.209V19.1z"
                                            className="cls-1"
                                            transform="translate(-.489 20.86)"
                                        />
                                        {" "}
                                        <path
                                            id="Path_766"
                                            d="M21.311.559L9.258 15.122s-1.83 1.728.155 1.728H16.2v21.218s-.271 1.032 1.293 1.032h9.56c1.123 0 1.09-.866 1.09-.866V17.281h6.28c2.418 0 .6-1.8.6-1.8S24.761 1.866 23.33.429a1.339 1.339 0 0 0-2.019.13z"
                                            className="cls-1"
                                            transform="translate(8.245)"
                                        />
                                        {" "}
                                    </g>
                                    {" "}
                                </svg>
                                <p>آپلود تصویر مزار</p>
                                <input
                                    type="file"
                                    name="image3"
                                    id="image3"
                                    onChange={addTombFileFromFilePicker}
                                    style={{display: 'none'}}
                                    className="dropify"
                                    data-allowed-file-extensions="gif png jpg jpeg"
                                    data-max-file-size="1M"
                                />
                            </div>
                        </div>
                        <div className="col-left">
                            <img
                                src={!tombPreview ? IMG_DIR + dead.pictureAddress : tombPreview}
                                alt=""
                                className="thumb radius10"
                                width={800}
                                height={222}
                            />
                        </div>
                        <input
                            type="text"
                            name="address"
                            placeholder="آدرس مزار:"
                            value={data.address}
                            onChange={(e) => {
                                setData({
                                    ...data,
                                    address: e.target.value,
                                })
                            }}
                            className="input box-sizing radius10"
                        />
                    </div>
                </div>
                <div className="pagewrapper" id="motevafa-details">
                    <div className="container">
                        <h2 className="main-title">جزئیات</h2>
                        <div className="input-wrapper">
                            <input
                                type="text"
                                name="name"
                                value={data.name}
                                onChange={(e) => {
                                    setData({
                                        ...data,
                                        name: e.target.value,
                                    })
                                }}
                                placeholder="نام و نام خانوادگی متوفی (مثلا شادروان ...)"
                                className="input box-sizing radius10"
                            />
                            <div className="input input-radio-wrapper box-sizing radius10 ease">
                                <span>جنسیت متوفی</span>
                                <div className="input-radio">
                                    <label htmlFor="male" className="radio">
                                        <span>مرد</span>
                                        {data.gender == "male" ?
                                            <input type="radio" id="male" name="gender" value="male" checked/> :
                                            <input type="radio" id="male" name="gender" value="male"/>}
                                    </label>
                                    <label htmlFor="female" className="radio">
                                        <span>زن</span>
                                        {data.gender == "female" ?
                                            <input type="radio" id="female" name="gender" value="female" checked/> :
                                            <input type="radio" id="female" name="gender" value="female"/>}
                                    </label>
                                </div>
                            </div>
                            <select
                                name="state" onChange={(e) => {
                                selectedStateIndex.current = e.target.value
                                getCities()
                            }} className="input select radius10 box-sizing ease"
                            >
                                <option value={-1}>استان</option>

                                {irStates.map((item, index) => (
                                    <option value={index}>{item.name}</option>
                                ))}

                            </select>
                            <select
                                name="city_id"
                                className="input select radius10 box-sizing ease" onChange={(e) => {
                                selectedCityIndex.current = e.target.value
                            }}
                            >
                                <option value={-1}>شهر</option>
                                {!isLoadingCities && irCities.map((item, index) => <option
                                    value={item.id}>{item.name}</option>)}
                            </select>
                            <input type="text" onClick={() => setIsShowingDatePicker1(true)} value={birthDate}
                                   name="birthday" placeholder="تاریخ تولد"
                                   className="input input-datepicker khatm-date box-sizing radius10 ease"
                                   onChange={(e) => {
                                       setBirthDate(e.target.value)
                                   }}/>
                            <input type="text" onClick={() => setIsShowingDatePicker2(true)} value={deadDate}
                                   name="deathDate" placeholder="تاریخ فوت"
                                   className="input input-datepicker die-date box-sizing radius10 ease"
                                   onChange={(e) => {
                                       setDeadDate(e.target.value)
                                   }}/>
                            <textarea
                                name="disc"
                                placeholder="توضیحات مندرج صفحه"
                                className="input message box-sizing radius10" value={dead.disc}
                            />
                        </div>
                        <div className="clear"/>
                    </div>
                </div>
                <div className="pagewrapper motevafa-checkboxes">
                    <div className="container">
                        <h2 className="main-title">انتخاب ادعیه و سوره</h2>
                        <div className="content">
                            {prays.map((item) => {
                                return <label
                                    key={item._id}
                                    htmlFor={item._id}
                                    className="item checkbox box-sizing radius10 adiye-item"
                                >
                                    <span>{item.name}</span>
                                    <input
                                        type="checkbox"
                                        onClick={soundHandle}
                                        id={item._id}
                                        name={item._id}
                                        value={item._id}
                                    />
                                </label>
                            })}

                        </div>
                    </div>
                </div>


                {/*<div className="pagewrapper motevafa-checkboxes display-none">*/}
                {/*    <div className="container">*/}
                {/*        <h2 className="main-title">صوت پیشفرض ورود به صفحه</h2>*/}
                {/*        <div className="content">*/}
                {/*            <label*/}
                {/*                htmlFor="sound1"*/}
                {/*                className="item radio box-sizing radius10 adiye-item"*/}
                {/*            >*/}
                {/*                <input*/}
                {/*                    type="radio"*/}
                {/*                    id="sound1"*/}
                {/*                    name="sound"*/}
                {/*                    defaultValue="صلوات"*/}
                {/*                />*/}
                {/*                <span>صلوات</span>*/}
                {/*            </label>*/}
                {/*            <label*/}
                {/*                htmlFor="sound2"*/}
                {/*                className="item radio box-sizing radius10 adiye-item"*/}
                {/*            >*/}
                {/*                <input*/}
                {/*                    type="radio"*/}
                {/*                    id="sound2"*/}
                {/*                    name="sound"*/}
                {/*                    defaultValue="بسم الله الرحمن الرحیم"*/}
                {/*                />*/}
                {/*                <span>بسم الله الرحمن الرحیم</span>*/}
                {/*            </label>*/}
                {/*            <label*/}
                {/*                htmlFor="sound3"*/}
                {/*                className="item radio box-sizing radius10 adiye-item"*/}
                {/*            >*/}
                {/*                <input*/}
                {/*                    type="radio"*/}
                {/*                    id="sound3"*/}
                {/*                    name="sound"*/}
                {/*                    defaultValue="سوره توحید"*/}
                {/*                />*/}
                {/*                <span>سوره توحید</span>*/}
                {/*            </label>*/}
                {/*            <label*/}
                {/*                htmlFor="sound4"*/}
                {/*                className="item radio box-sizing radius10 adiye-item"*/}
                {/*            >*/}
                {/*                <input*/}
                {/*                    type="radio"*/}
                {/*                    id="sound4"*/}
                {/*                    name="sound"*/}
                {/*                    defaultValue="سوره کوثر"*/}
                {/*                />*/}
                {/*                <span>سوره کوثر</span>*/}
                {/*            </label>*/}
                {/*            <label*/}
                {/*                htmlFor="sound5"*/}
                {/*                className="item radio box-sizing radius10 adiye-item"*/}
                {/*            >*/}
                {/*                <input*/}
                {/*                    type="radio"*/}
                {/*                    id="sound5"*/}
                {/*                    name="sound"*/}
                {/*                    defaultValue="سلام به امام حسین (ع)"*/}
                {/*                />*/}
                {/*                <span>سلام به امام حسین (ع)</span>*/}
                {/*            </label>*/}
                {/*            <label*/}
                {/*                htmlFor="sound6"*/}
                {/*                className="item radio box-sizing radius10 adiye-item"*/}
                {/*            >*/}
                {/*                <input*/}
                {/*                    type="radio"*/}
                {/*                    id="sound6"*/}
                {/*                    name="sound"*/}
                {/*                    defaultValue="هیچکدام"*/}
                {/*                />*/}
                {/*                <span>هیچکدام</span>*/}
                {/*            </label>*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*</div>*/}


                {/*<div className="pagewrapper display-none" id="motevafa-gallery-upload">*/}
                {/*    <div className="container">*/}
                {/*        <h2 className="main-title">آپلود تیزر و گالری تصاویری از متوفی</h2>*/}
                {/*        <div className="content">*/}
                {/*            <div className="upload-box box-sizing radius10">*/}
                {/*                <div className="upload-btn box-sizing radius10">*/}
                {/*                    <svg*/}
                {/*                        xmlns="http://www.w3.org/2000/svg"*/}
                {/*                        width={55}*/}
                {/*                        height={55}*/}
                {/*                        fill="#fff"*/}
                {/*                        viewBox="0 0 53.18 54.738"*/}
                {/*                    >*/}
                {/*                        {" "}*/}
                {/*                        <defs>*/}
                {/*                            <style*/}
                {/*                                dangerouslySetInnerHTML={{*/}
                {/*                                    __html: ".cls-1{fill:#fff}",*/}
                {/*                                }}*/}
                {/*                            />*/}
                {/*                        </defs>*/}
                {/*                        {" "}*/}
                {/*                        <path*/}
                {/*                            id="Path_755"*/}
                {/*                            d="M44.87 0H8.309C3.727 0 0 4.127 0 9.2v32.2c0 5.073 3.727 9.2 8.309 9.2h28.356a2.312 2.312 0 0 0 0-4.6h-7.651l-4.776-6.86 15.135-21.317 10.189 12.469a1.943 1.943 0 0 0 2.287.6 2.308 2.308 0 0 0 1.33-2.146V9.2c0-5.073-3.727-9.2-8.309-9.2zm4.155 22.779L40.8 12.716a1.984 1.984 0 0 0-1.612-.756 2.021 2.021 0 0 0-1.561.877L21.621 35.38l-5.434-7.805a2.014 2.014 0 0 0-1.645-.9 2.014 2.014 0 0 0-1.645.9l-4.572 6.58a2.468 2.468 0 0 0 .38 3.225 1.947 1.947 0 0 0 2.914-.42l2.927-4.213L23.768 46H8.309a4.4 4.4 0 0 1-4.155-4.6V9.2a4.4 4.4 0 0 1 4.155-4.6H44.87a4.4 4.4 0 0 1 4.155 4.6zm0 0"*/}
                {/*                            className="cls-1"*/}
                {/*                        />*/}
                {/*                        {" "}*/}
                {/*                        <path*/}
                {/*                            id="Path_756"*/}
                {/*                            d="M86.232 72C82.8 72 80 75.1 80 78.9s2.8 6.9 6.232 6.9 6.232-3.1 6.232-6.9-2.795-6.9-6.232-6.9zm0 9.2a2.312 2.312 0 1 1 2.077-2.3 2.2 2.2 0 0 1-2.077 2.3zm0 0"*/}
                {/*                            className="cls-1"*/}
                {/*                            transform="translate(-71.691 -63.72)"*/}
                {/*                        />*/}
                {/*                        {" "}*/}
                {/*                        <path*/}
                {/*                            id="Path_757"*/}
                {/*                            d="M364.994 289.718l-.018-.021a4.833 4.833 0 0 0-7.347-.01l-4.011 4.38a2.477 2.477 0 0 0-.02 3.252 1.938 1.938 0 0 0 2.938.022l2.685-2.931v12.909a2.088 2.088 0 1 0 4.155 0V294.48l2.569 2.939a1.939 1.939 0 0 0 2.938.053 2.477 2.477 0 0 0 .047-3.252zm0 0"*/}
                {/*                            className="cls-1"*/}
                {/*                            transform="translate(-316.335 -254.881)"*/}
                {/*                        />*/}
                {/*                        {" "}*/}
                {/*                    </svg>*/}
                {/*                    <p>فایل را اینجا رها کنید</p>*/}
                {/*                    <input*/}
                {/*                        type="file"*/}
                {/*                        name="image4"*/}
                {/*                        className="dropify"*/}
                {/*                        data-allowed-file-extensions="gif png jpg jpeg"*/}
                {/*                        data-max-file-size="1M"*/}
                {/*                    />*/}
                {/*                </div>*/}
                {/*                <div className="left-col box-sizing">*/}
                {/*                    جهت تغییر تصویر بالا لورم ایپسوم متن ساختگی با تولید سادگی*/}
                {/*                    نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است چاپگرها*/}
                {/*                    و متون بلکه روزنامه*/}
                {/*                </div>*/}
                {/*            </div>*/}
                {/*            <div className="clear"/>*/}
                {/*            <a href="#" className="btn blue box-sizing ease radius10">*/}
                {/*                سفارش ساخت تیزر*/}
                {/*            </a>*/}
                {/*            <a href="#" className="btn green box-sizing ease radius10">*/}
                {/*                آپلود تیزر و تصاویر*/}
                {/*            </a>*/}
                {/*        </div>*/}
                {/*    </div>*/}
                {/*</div>*/}
                <div className="pagewrapper" id="motevafa-profile-button">
                    <div className="container">
                        <button type="submit" className="create-page-btn radius10 ease">
                            ایجاد صفحه
                        </button>
                    </div>
                </div>
            </form>}
            <div className="clear"/>
            <Footer/>
        </>
    );
};

export default MotevafaEdit;
